import axios from "axios";
import Utility from "../../../shared/utility";
import { store } from "../../../state-management/state-mgmt";
export default {
  countryList(userId, countryKey, pass, call) {
    return this.getData(`/cp/country_state_details_new?user_id=${userId}&country_key=${countryKey}&pass=${pass}`, call);
  },
  postCustomerListSearch(call, obj) {
    return this.getData("/cu/customer_search", call, obj);
  },
  uploadCustomerList(call, obj) {
    return this.getData("/cu/customer_bulk_upload", call, obj);
  },
  uploadSearchDetails(call, obj) {
    return this.getData("/cu/customer_upload_search_details", call, obj);
  },
  uploadErrorDetails(call, obj) {
    return this.getData("/cu/customer_upload_error_details", call, obj);
  },
  getCustomerDataById(CustId,UserId) {
    let call = "get";
    return this.getData(`/cu/customer_data_by_id?CustId=${CustId}&UserId=${UserId}`, call);
  },
  validateCustomerDataById(userId, CustNo) {
    let call = "get";
    return this.getData(`/cu/custno_validate?UserId=${userId}&CustNo=${CustNo}&pass=1`, call);
  },
  postAddCustomer(call, obj, showMessage) {
    return this.getData("/cu/customer_upsert", call, obj, showMessage);
  },
  getProject(userId) {
    let call = "get";
    return this.getData(`cp/project_header?pass=1&user_id=${userId}`, call);
  },
  async getData(url, call, obj, showMessage) {
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    let res = {};
    if (call == "get") {
      res = await axios.get(url).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    } else {
      res = await axios.post(url, obj).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    }
    //When Response is having body as null
    if (res == undefined || res == null) {
      LoaderDialog.visible = false;
      store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      return JSON.parse('{"message":"NA"}');
    }
    if (res.data.body.message != undefined || res.data.body.message != null) {
      //When message in response is coming as string
      if (typeof res.data.body.message == "string") {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.body.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return res.data.body.message;
        } else {
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return res.data.body.message;
        }
      }
      if (!res?.data?.body?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res.data.body.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.body.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse(res?.data?.body?.message);
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    } else if (res.data.body.message == null) {
      LoaderDialog.visible = false;
      store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      return JSON.parse('{"message":"NA"}');
    } else {
      if (!res?.data?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res.data.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse(res?.data?.message);
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    }
  },
};
